// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host, .sidebar {
  height: 100%;
}

.sidebar {
  display: flex;
  flex-direction: column;
  transition: width 0.25s cubic-bezier(0, 0, 0.2, 1);
  border: none;
  border-right: 1px solid var(--gc-border-color);
  box-shadow: var(--gc-box-shadow);
}
.sidebar-default {
  width: 240px;
}
.sidebar-default .logo img {
  transition: 0.25s 0.25s cubic-bezier(0, 0, 0.2, 1);
}
.sidebar-minimized {
  width: 42px;
}
.sidebar-minimized .entry-label, .sidebar-minimized .entry-tags, .sidebar-minimized .entry-action {
  opacity: 0;
  display: none;
  height: 19px;
}
.sidebar-minimized .draft-container {
  display: none;
}
.sidebar-hidden {
  width: 0;
}
.sidebar .content {
  flex-grow: 1;
  position: relative;
  display: grid;
}
.sidebar .content .pin {
  position: absolute;
  bottom: -5px;
  left: -3px;
}

ul {
  margin: 0;
  padding: 0;
}
ul li {
  list-style: none;
}
ul li a {
  color: var(--gc-text-color);
  text-decoration: none;
}

.scroll-container {
  flex-grow: 1;
  position: relative;
  height: 100%;
}
.scroll-container .scroll-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: overlay;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.logo {
  border-right: 1px solid var(--gc-background-color);
  margin: 0 -1px 0 0;
  flex: 0 0 52px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--gc-border-color);
  background-color: var(--gc-background-color);
}
.logo img {
  margin: 0 9px;
  max-height: 1.5rem;
  max-width: unset;
}

.menu {
  margin-right: -5px;
  display: flex;
  flex-direction: column;
  overflow: overlay;
}

.entry .children {
  overflow: hidden;
  padding-left: 2.3rem;
}
.entry.entry-level-1 {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  margin: 0;
}
.entry.entry-level-1.entry-expanded > .entry-title {
  border-color: var(--gc-border-color) !important;
}
.entry-selected-path, .entry-expanded {
  border-color: var(--gc-border-color) !important;
  background: var(--gc-color-light-tint);
  margin: -1px;
  overflow: hidden;
}
.entry:hover:not(.entry-expanded):not(.entry-selected) {
  background: var(--gc-color-light-shade);
}
.entry-selected {
  background: rgba(var(--gc-color-primary-rgb), 0.5);
  font-weight: bold;
}
.entry-icon {
  flex: 0 0 20px;
  display: flex;
  justify-content: center;
}
.entry-icon.left-icon {
  margin-right: 1rem;
}
.entry-tag {
  white-space: nowrap;
  display: block;
  padding: 0.25rem;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  margin: 0 0.5rem;
}
.entry-tags {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}
.entry-title {
  padding: 15px 10px;
  height: 42px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.entry-title .entry-label {
  min-width: 140px;
  width: 100%;
}
.entry-title .entry-label:first-child {
  margin-left: 0;
}

.draft, .draft-container {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: 1rem;
}
.draft .counter, .draft-container .counter {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.draft .header, .draft-container .header {
  padding: 1rem;
  padding-bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}
.draft .header .title, .draft-container .header .title {
  font-weight: 700;
  line-height: 1.5;
}
.draft .content, .draft-container .content {
  position: relative;
}
.draft .content .scroll-container, .draft-container .content .scroll-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: overlay;
  scrollbar-gutter: stable;
  overflow-x: hidden;
}
.draft .draft-selector, .draft-container .draft-selector {
  margin-right: -0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.draft .draft-selector-icon, .draft .draft-selector-element .delete, .draft-container .draft-selector-icon, .draft-container .draft-selector-element .delete {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
}
.draft .draft-selector-element, .draft-container .draft-selector-element {
  display: flex;
  gap: 0.5rem;
  height: 43px;
  padding: 6px;
  cursor: pointer;
  align-items: center;
}
.draft .draft-selector-element:hover, .draft-container .draft-selector-element:hover {
  background-color: var(--gc-color-light-shade);
}
.draft .draft-selector-element .draft-selector-label, .draft-container .draft-selector-element .draft-selector-label {
  flex-grow: 1;
  cursor: pointer;
  line-height: 0.25rem;
}
.draft .draft-selector-element .draft-selector-label .title, .draft .draft-selector-element .draft-selector-label .small, .draft-container .draft-selector-element .draft-selector-label .title, .draft-container .draft-selector-element .draft-selector-label .small {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 158px;
}
.draft .draft-selector-element .draft-selector-label .small, .draft-container .draft-selector-element .draft-selector-label .small {
  line-height: 1rem;
  font-size: small;
}
.draft .draft-selector-element.active, .draft-container .draft-selector-element.active {
  background-color: var(--gc-color-primary);
  color: var(--gc-text-color-inverse);
}
.draft .draft-selector-element.active:hover, .draft-container .draft-selector-element.active:hover {
  background-color: var(--gc-color-primary-shade);
}

@keyframes delay-overflow {
  from {
    display: initial;
  }
}
@media (prefers-color-scheme: dark) {
  .logo img {
    filter: brightness(0) invert(1);
  }
}
::-webkit-scrollbar {
  width: 5px;
}

.pre-line {
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-left-sidebar/v-left-sidebar.component.sass"],"names":[],"mappings":"AAEA;EACI,YAAA;AADJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,YAAA;EACA,8CAAA;EACA,gCAAA;AAAJ;AAEI;EACI,YAAA;AAAR;AAEY;EACI,kDAAA;AAAhB;AACI;EACI,WAnBG;AAoBX;AACY;EACI,UAAA;EACA,aAAA;EACA,YAAA;AAChB;AAAQ;EACI,aAAA;AAEZ;AAAI;EACI,QAAA;AAER;AADI;EACI,YAAA;EACA,kBAAA;EACA,aAAA;AAGR;AAFQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AAIZ;;AAFA;EACI,SAAA;EACA,UAAA;AAKJ;AAJI;EACI,gBAAA;AAMR;AALQ;EACI,2BAAA;EACA,qBAAA;AAOZ;;AAJA;EACI,YAAA;EACA,kBAAA;EACA,YAAA;AAOJ;AANI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAQR;;AANA;EACI,kDAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EAEA,mBAAA;EACA,+CAAA;EACA,4CAAA;AAQJ;AANI;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;AAQR;;AANA;EAEI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAQJ;;AANI;EACI,gBAAA;EACA,oBAAA;AASR;AARI;EACI,iCAAA;EACA,oCAAA;EACA,SAAA;AAUR;AARQ;EACI,+CAAA;AAUZ;AATI;EACI,+CAAA;EACA,sCAAA;EACA,YAAA;EACA,gBAAA;AAWR;AAVI;EACI,uCAAA;AAYR;AAXI;EACI,kDAAA;EACA,iBAAA;AAaR;AAZI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;AAcR;AAbQ;EACI,kBAAA;AAeZ;AAdI;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAgBR;AAfI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;AAiBR;AAhBI;EACI,kBAAA;EACA,YA9HG;EA+HH,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAkBR;AAhBY;EACI,gBAAA;EACA,WAAA;AAkBhB;AAjBgB;EACI,cAAA;AAmBpB;;AAjBA;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAoBJ;AAnBI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAqBR;AApBI;EACI,aAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AAsBR;AArBQ;EACI,gBAAA;EACA,gBAAA;AAuBZ;AApBI;EACI,kBAAA;AAsBR;AArBQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;AAuBZ;AArBI;EACI,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAuBR;AAtBQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAwBZ;AAvBQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAyBZ;AAxBY;EACI,6CAAA;AA0BhB;AAvBgB;EACI,YAAA;EACA,eAAA;EACA,oBAAA;AAyBpB;AAxBoB;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AA0BxB;AAzBoB;EACI,iBAAA;EACA,gBAAA;AA2BxB;AA1BY;EACI,yCAAA;EACA,mCAAA;AA4BhB;AA3BgB;EACI,+CAAA;AA6BpB;;AA3BA;EACI;IACI,gBAAA;EA8BN;AACF;AA7BA;EACI;IACI,+BAAA;EA+BN;AACF;AA9BA;EACE,UAAA;AAgCF;;AA9BA;EACI,qBAAA;AAiCJ","sourcesContent":["$iconSize: 42px\n\n:host, .sidebar\n    height: 100%\n\n.sidebar\n    display: flex\n    flex-direction: column\n    transition: width .25s cubic-bezier(0, 0, 0.2, 1)\n    border: none\n    border-right: 1px solid var(--gc-border-color)\n    box-shadow: var(--gc-box-shadow)\n        \n    &-default\n        width: 240px\n        .logo\n            img\n                transition: .25s .25s cubic-bezier(0, 0, 0.2, 1)\n    &-minimized\n        width: $iconSize\n        .entry\n            &-label, &-tags, &-action\n                opacity: 0\n                display: none\n                height: 19px\n        .draft-container\n            display: none\n            \n    &-hidden\n        width: 0\n    .content\n        flex-grow: 1\n        position: relative\n        display: grid\n        .pin\n            position: absolute\n            bottom: -5px\n            left: -3px\n\nul\n    margin: 0\n    padding: 0\n    li\n        list-style: none\n        a\n            color: var(--gc-text-color)\n            text-decoration: none\n\n\n.scroll-container\n    flex-grow: 1\n    position: relative\n    height: 100%\n    .scroll-content\n        position: absolute\n        top: 0\n        right: 0\n        bottom: 0\n        left: 0\n        overflow-y: overlay\n        overflow-x: hidden\n        scrollbar-gutter: stable\n\n.logo\n    border-right: 1px solid var(--gc-background-color)\n    margin: 0 -1px 0 0\n    flex: 0 0 52px\n    display: flex\n    // justify-content: center\n    align-items: center\n    border-bottom: 1px solid var(--gc-border-color)\n    background-color: var(--gc-background-color)\n    // cursor: pointer\n    img\n        margin: 0 9px\n        max-height: 1.5rem\n        max-width: unset\n    \n.menu\n    // width: 100%\n    margin-right: -5px\n    display: flex\n    flex-direction: column\n    overflow: overlay\n.entry\n    .children\n        overflow: hidden\n        padding-left: 2.3rem\n    &.entry-level-1\n        border-top: 1px solid transparent\n        border-bottom: 1px solid transparent\n        margin: 0\n        \n        &.entry-expanded > .entry-title\n            border-color: var(--gc-border-color) !important\n    &-selected-path,&-expanded\n        border-color: var(--gc-border-color) !important\n        background: var(--gc-color-light-tint)\n        margin: -1px\n        overflow: hidden\n    &:hover:not(.entry-expanded):not(.entry-selected)\n        background: var(--gc-color-light-shade)\n    &-selected\n        background: rgba(var(--gc-color-primary-rgb), 0.5)\n        font-weight: bold\n    &-icon\n        flex: 0 0 20px\n        display: flex\n        justify-content: center\n        &.left-icon\n            margin-right: 1rem\n    &-tag\n        white-space: nowrap\n        display: block\n        padding: 0.25rem\n        border-radius: 4px\n        font-size: 0.75rem\n        line-height: 0.75rem\n        text-align: center\n        margin: 0 0.5rem\n    &-tags\n        flex-grow: 1\n        display: flex\n        justify-content: flex-end\n    &-title\n        padding: 15px 10px\n        height: $iconSize\n        width: 100%\n        display: flex\n        align-items: center\n        cursor: pointer\n        .entry\n            &-label\n                min-width: 140px\n                width: 100%\n                &:first-child\n                    margin-left: 0\n    \n.draft, .draft-container\n    display: flex\n    justify-content: flex-end\n    align-items: stretch\n    flex-direction: column\n    height: 100%\n    width: 100%\n    gap: 1rem\n    .counter\n        display: flex\n        justify-content: center\n        cursor: pointer\n    .header\n        padding:  1rem\n        padding-bottom: 0\n        display: flex\n        justify-content: flex-start\n        align-items: center\n        gap: 1rem\n        .title\n            font-weight: 700\n            line-height: 1.5\n        .counter\n            // margin: 2px 1rem 1rem 1rem\n    .content\n        position: relative\n        .scroll-container\n            position: absolute\n            top: 0\n            left: 0\n            bottom: 0\n            right: 0\n            overflow-y: overlay\n            scrollbar-gutter: stable\n            overflow-x: hidden\n\n    .draft-selector\n        margin-right: -0.25rem\n        display: flex\n        flex-direction: column\n        gap: 0.25rem\n        &-icon, &-element .delete\n            width: 26px\n            height: 26px\n            flex-shrink: 0\n            display: grid\n            place-items: center\n        &-element\n            display: flex\n            gap: 0.5rem\n            height: 43px\n            padding: 6px\n            cursor: pointer\n            align-items: center\n            &:hover\n                background-color: var(--gc-color-light-shade)\n\n            .draft-selector\n                &-label\n                    flex-grow: 1\n                    cursor: pointer\n                    line-height: 0.25rem\n                    .title, .small\n                        overflow: hidden\n                        white-space: nowrap\n                        text-overflow: ellipsis\n                        display: block\n                        width: 158px\n                    .small\n                        line-height: 1rem\n                        font-size: small\n            &.active\n                background-color: var(--gc-color-primary)\n                color: var(--gc-text-color-inverse)\n                &:hover\n                    background-color: var(--gc-color-primary-shade)\n\n@keyframes delay-overflow\n    from\n        display: initial\n                    \n@media(prefers-color-scheme: dark)\n    .logo img\n        filter: brightness(0) invert(1)\n\n::-webkit-scrollbar\n  width: 5px\n\n.pre-line\n    white-space: pre-line"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
